// extracted by mini-css-extract-plugin
module.exports = {"data":"list_data__2CNHk","header":"list_header__3W7rs","first":"list_first__4nwXh","variable":"list_variable__89mAc","item":"list_item__1uN3w","closeIcon":"list_closeIcon__1yBmK"};